document.addEventListener("DOMContentLoaded", () => {
    const explore = document.querySelector(".postage-navigation .explore");
    const forYou = document.querySelector(".postage-navigation .for-you");
    const following = document.querySelector(".postage-navigation .following");
    const saved = document.querySelector(".postage-navigation .saved");

    const logged = devtricker_getTheLoggedUserId();

    if (explore) {

        if (!logged) {
            explore.classList.remove("active");

            if (window.location.pathname === '/explore/') {
                devtricker_openSocialLoginModal();
            }
        }

        explore.addEventListener("click", (event) => {
            if (!devtricker_getTheLoggedUserId()) {
                event.preventDefault();
                event.stopImmediatePropagation();
                devtricker_openSocialLoginModal(event);
            }
        });
    }

    if (forYou) {

        if (!logged) {
            forYou.classList.remove("active");
        }

        forYou.addEventListener("click", (event) => {
            if (!devtricker_getTheLoggedUserId()) {
                event.preventDefault();
                event.stopImmediatePropagation();
                devtricker_openSocialLoginModal(event);
            }
        });
    }

    if (following) {

        if (!logged) {
            following.classList.remove("active");

            if (window.location.pathname === '/following/') {
                devtricker_openSocialLoginModal();
            }
        }

        following.addEventListener("click", (event) => {
            if (!devtricker_getTheLoggedUserId()) {
                event.preventDefault();
                event.stopImmediatePropagation();
                devtricker_openSocialLoginModal(event);
            }
        });
    }

    if (saved) {

        if (!logged) {
            saved.classList.remove("active");

            if (window.location.pathname === '/saved/') {
                devtricker_openSocialLoginModal();
            }
        }

        saved.addEventListener("click", (event) => {
            if (!devtricker_getTheLoggedUserId()) {
                event.preventDefault();
                event.stopImmediatePropagation();
                devtricker_openSocialLoginModal(event);
            }
        });
    }
});


document.addEventListener('DOMContentLoaded', () => {
    const checkedInputs = document.querySelectorAll('input.checked');
    checkedInputs.forEach(input => {
        input.checked = true;
    });
});